// Define variables.
let goal, activity, workout, diet, sex, age, height, heightFt, heightIn, heightUnit, currentWeight, currentWeightUnit, currentWeightLbs, targetWeight, targetWeightUnit, targetWeightLbs, email, userName, agreeTerms, isValid = '', macrosResult, userCaloriesPerDay, personalisedColl;

// Robust email regex — requires a valid TLD (rejects e.g. "user@domain" or "fafd@fdas")
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

function isValidEmail(value) {
  return EMAIL_REGEX.test(value.trim());
}

// Function to validate the form
function validateForm() {
  goal = getValue('goal');
  activity = getValue('activity');
  workout = getValue('workout');
  diet = getValue('diet');
  sex = getValue('sex');
  age = document.getElementById('age').value;
  height = getHeight();
  currentWeight = getWeight('current-weight');
  targetWeight = getWeight('target-weight');
  email = getTextValue('email');
  userName = getTextValue('user-name');
  agreeTerms = document.getElementById('agree_terms').checked;
  console.log('called');
  console.log(`age-${age} | height-${height} | currentWeight-${currentWeight}| targetWeight-${targetWeight}| agreeTerms-${agreeTerms} `);
  isValid = age && height && currentWeight && targetWeight && agreeTerms && isValidEmail(email);
  return isValid;
}

function reccDiet(diet) {
  const dietMappings = {
    'High-Protein Moderate-Carb': 'Low Carb + High Protein: (45 : 35 : 20)',
    'Moderate-Protein High-Carb': 'Moderate-Protein High-Carb (35 : 45 : 20)',
    'Keto': 'Keto (30 : 5 : 65)'
  };

  displayElement('recc_diet', dietMappings[diet] || 'Reccommendation N/A');
}

function setMacros(calories, protein, carbs, fat) {
  displayMacros('result-protein', 'Protein', protein, calories);
  displayMacros('result-carbs', 'Carbs', carbs, calories);
  displayMacros('result-fat', 'Fat', fat, calories);
}


function displayMacros(elementId, label, ratio, calories) {
  const macroElement = document.getElementById(elementId);
  const macroElementShare = document.getElementById(elementId+'-share');
  const macrosSplitBarWrap = document.querySelector('#macros-split-bar-wrap .macros-split-bar');

  
  let divide_by = 0;
  if (label === 'Fat') {
    divide_by = 9;
  } else {
    divide_by = 4;
  }

  if (macroElement) {
    macroElementShare.style.width=`${ratio * 100}%`;
    macroElement.innerHTML = `
      <span class="title">${label}</span>
      <span class="value">${ratio * 100}% &bull; ${Math.round(ratio * calories / divide_by)}g</span>
      `;
    macrosSplitBarWrap.classList.add('active');
  }
}


function getDietMacroRatios(diet) {
  const mappings = {
    'High-Protein Moderate-Carb': { protein: 0.45, carbs: 0.35, fat: 0.20 },
    'Moderate-Protein High-Carb': { protein: 0.35, carbs: 0.45, fat: 0.20 },
    'Keto': { protein: 0.30, carbs: 0.05, fat: 0.65 }
  };
  return mappings[diet];
}

function calculateMacros() {
  
  let supplementRecommendations = [];
  let calculatorResultField = '';
  let tdee = calculateTDEE();

  const goalCalories = calculateGoalCalories(tdee);
  userCaloriesPerDay = goalCalories.toLocaleString();
  displayElement('result-calories', `${userCaloriesPerDay} per day`);

  const dietMacros = (diet === 'oderate-Protein High-Carb') ? getDietMacroRatios('oderate-Protein High-Carb') : getDietMacroRatios(diet);
  reccDiet(diet);

  supplementRecommendations = getSupplementRecom();
  calculatorResultField = supplementRecommendations.join(', ');

  displayElement('macros-results', calculatorResultField, true, true);
 
  document.documentElement.scrollTo({
      top: 120,
      behavior: 'smooth'
  });
  
  // We wait for 3.5 seconds to emulate calculation before displaying the results.
  setTimeout(() => {    
    const activeStep = document.querySelector('.question-step.step-active');
    if (activeStep) {
      activeStep.classList.remove('step-active');
      const nextStep = activeStep.nextElementSibling;
      if (nextStep && nextStep.classList.contains('question-step')) {
        nextStep.classList.add('step-active');
      }
    }
    setMacros(goalCalories, dietMacros.protein, dietMacros.carbs, dietMacros.fat);
    displayGoalAndResultFields();
    
  }, "3500");

  macrosResult = document.querySelector(`input[name="macros_results"]`).value;
  buyMyProductsBtn = document.querySelectorAll('.buy-my-products');
  buyMyProductsBtn.forEach(function(input) {
      input.href = `/collections/your-personalized-products/${personalisedColl}`;
  });
  personalizedProducts = document.querySelector('.personalized-products');
  personalizedProducts.className = 'personalized-products';
  personalizedProducts.classList.add(personalisedColl);
}

function calculateTDEE() {
  let tdee = 10 * currentWeight + 6.25 * height - 5 * age;

  if (sex === 'Male') {
    tdee += 5;
  } else if (sex === 'Female') {
    tdee -= 161;
  }

  tdee = adjustTDEEForActivity(tdee);
  return tdee.toFixed(0);
}

function adjustTDEEForActivity(tdee) {
  const activityMultipliers = {
    'Very Light': 1.2,
    'Light': 1.375,
    'Moderate': 1.55,
    'Heavy': 1.725
  };

  return tdee * activityMultipliers[activity];
}

function calculateGoalCalories(tdee) {
  let goalMultiplier = 0;

  if (goal === 'Lose Fat') {
    goalMultiplier = 0.8;
    personalisedColl= 'goal-lose-fat';
  } else if (goal === 'Body Recomposition') {
    goalMultiplier = 0.9;
    personalisedColl= 'goal-body-recomposition';
  } else if (goal === 'Build Muscle') {
    goalMultiplier = 1.2;
    personalisedColl= 'goal-build-muscle';
  }

  return Math.floor(tdee * goalMultiplier);
}

function getSupplementRecom() {
  const baseRecommendations = ['Huge Whey'];

  if (goal === 'Lose Fat') {
    return [...baseRecommendations, ''];
  } else if (goal === 'Body Recomposition') {
    return [...baseRecommendations, ''];
  } else if (goal === 'Build Muscle') {
    return [...baseRecommendations, '', ''];
  }
}

function displayGoalAndResultFields() {
  const goalMappings = {
    'Lose Fat': 'Lose Fat',
    'Body Recomposition': 'Body Recomposition',
    'Build Muscle': 'Bulk Up'
  };

  displayElement('macros-goal', goalMappings[goal], true, true);
  displayElement('results', 'hidden', false);
}

function getValue(elementId) {
  const selectedElement = document.querySelector(`input[name="${elementId}"]:checked`);
  return selectedElement ? selectedElement.value : '';
}

function getTextValue(elementId) {
  const selectedElement = document.querySelector(`input[name="${elementId}"]`);
  return selectedElement ? selectedElement.value : '';
}

function getHeight() {
  heightUnit = getValue('height-unit');
  heightFt = Number(document.querySelector('input[name="height-ft"]').value);
  heightIn = Number(document.querySelector('input[name="height-in"]').value);
  const heightCm = Number(document.querySelector('input[name="height-cm"]').value);

  let ft_in_ht = ((heightFt * 12) + heightIn) * 2.54;
  return (heightUnit === 'ft') ? ft_in_ht.toFixed(2) : heightCm;
}

function getWeight(elementId) {
  currentWeightUnit = getValue('current-weight-unit');
  targetWeightUnit = getValue('target-weight-unit');
  
  let weight = 0;
  let inputs = document.querySelectorAll(`input[name="${elementId}"]`);
  inputs.forEach(function(input) {
      if (input.style.display != 'none') { 
        weight = input.value;
      }
  });
  
  let kg_weight = weight/2.2045;
  let selectedUnit = document.querySelector(`input[name="${elementId}-unit"]:checked`).value;
  if(selectedUnit === 'lbs'){
    if (elementId == 'current-weight') {
      currentWeightLbs = weight;
    } else {
      targetWeightLbs = weight;
    }
  }
  return (selectedUnit === 'lbs') ? kg_weight.toFixed(2) : weight;
}

function displayElement(elementId, value, hidden = true, text = false) {
  const element = document.getElementById(elementId);
  if (element) {
    if (hidden) {
      element.innerText = value;
    } else {
      element.classList.remove(value);
    }
    if (text) {
      element.value = value;
    }
  }
}

document.getElementById('macros-form').addEventListener('submit', function (e) {
  e.preventDefault();
  const error_msg = document.getElementById('error_msg');
  if (validateForm()) {
    console.log('the form is valid');
    error_msg.classList.remove('show');
    setTimeout(function() {
      var currentQuestionStep = document.querySelector('.question-step.step-active');
      currentQuestionStep.classList.remove('step-active');
    
      var nextQuestionStep = currentQuestionStep.nextElementSibling;
      if (nextQuestionStep && nextQuestionStep.classList.contains('question-step')) {
        nextQuestionStep.classList.add('step-active');
        var firstInput = nextQuestionStep.querySelector('input:first-child');
    
        if (firstInput) {
          firstInput.focus();
        }
      }

      var activeSteps = document.querySelectorAll('.question-step.step-active.summary');

      activeSteps.forEach(function(step) {
        var stepElements = step.querySelectorAll('.step');
        stepElements.forEach(function(element) {
          if (element.classList.contains('your-goal')) {
            element.querySelector('.value').textContent = goal;
          } else if (element.classList.contains('activity-level')) {
            element.querySelector('.value').textContent = activity;
          } else if (element.classList.contains('weekly-workouts')) {
            element.querySelector('.value').textContent = workout;
          } else if (element.classList.contains('your-diet')) {
            element.querySelector('.value').textContent = diet;
          } else if (element.classList.contains('about-you')) {
            element.querySelector('.age .value').innerHTML = age+'<span>years</span>';
            element.querySelector('.sex .value').innerHTML = sex;
            let userHeight = heightUnit === 'ft' ? heightFt + '<span>Ft</span> ' + heightIn + '<span>in</span>' : height + '<span>cm</span>';
            element.querySelector('.height .value').innerHTML = userHeight;

            let userCurrentWt = currentWeightUnit === 'lbs' ? currentWeightLbs + '<span>Lbs</span>' : currentWeight + '<span>Kg</span>';
            element.querySelector('.current-weight .value').innerHTML = userCurrentWt;

            let userTargetWt = targetWeightUnit === 'lbs' ? targetWeightLbs + '<span>Lbs</span>' : targetWeight + '<span>Kg</span>';
            element.querySelector('.target-weight .value').innerHTML = userTargetWt;

            element.querySelector('.email .value').innerHTML = email;
            element.querySelector('.name .value').innerHTML = userName;
            
          }
        });
      });
    }, 500);

    var active_step = document.querySelector('.question-step.step-active');
    if (active_step.classList.contains('summary')) {
      calculateMacros();
    }
    subsUsrKlaviyo();
  } else {
    error_msg.classList.add('show');
    console.log('the form is invalid');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const agreeTerms = document.getElementById("agree_terms");
  const calcMacBtn = document.querySelector(".calculate-macro-btn");
  const heightUnitGroup = document.forms["macros-form"]["height-unit"];
  const currentWtUnitGroup = document.forms["macros-form"]["current-weight-unit"];
  const targetWtUnitGroup = document.forms["macros-form"]["target-weight-unit"];

  agreeTerms.addEventListener("change", function () {
    calcMacBtn.disabled = !this.checked;
  });

  // Email validation — show error on blur if invalid, clear on input
  const emailInput = document.getElementById('k_id_email');
  emailInput.addEventListener('blur', function () {
    if (this.value && !isValidEmail(this.value)) {
      this.setCustomValidity('Please enter a valid email address (e.g. name@example.com)');
      this.reportValidity();
      this.classList.add('input--error');
    } else {
      this.setCustomValidity('');
      this.classList.remove('input--error');
    }
  });
  emailInput.addEventListener('input', function () {
    this.setCustomValidity('');
    this.classList.remove('input--error');
  });

  // Toggle unit metric switch input for height.
  for (let i = 0; i < heightUnitGroup.length; i++) {
    heightUnitGroup[i].addEventListener("change", function () {
      toggleHeightInputs();
    });
  }

  // Toggle unit metric switch input for current weight.
  for (let i = 0; i < currentWtUnitGroup.length; i++) {
    currentWtUnitGroup[i].addEventListener("change", function () {
      toggleCurrentWtInputs();
    });
  }
  
  // Toggle unit metric switch input for target weight.
  for (let i = 0; i < targetWtUnitGroup.length; i++) {
    targetWtUnitGroup[i].addEventListener("change", function () {
      toggleTargetWtInputs();
    });
  }

  // Function to toggle unit metric inputs for height.
  function toggleHeightInputs() {
    heightUnit = document.querySelector('input[name="height-unit"]:checked').value;
    let ftInputs = document.querySelectorAll('.height-unit-input[data-unit="ft"]');
    let cmInputs = document.querySelectorAll('.height-unit-input[data-unit="cm"]');
    let htInputFt = document.querySelector('#height_ft');
    let htInputIn = document.querySelector('#height_in');
    let htInputCm = document.querySelector('#height_cm');

    
    ftInputs.forEach(e => {
      e.style.display = (heightUnit === 'ft') ? 'flex' : 'none';
      if (heightUnit === 'ft') {
        let firstInput = e.querySelector('input');
        if (firstInput) {
          firstInput.focus();
          htInputFt.required = true;
          htInputFt.style.display = 'block';
          htInputCm.required = false;
          htInputCm.style.display = 'none';
          htInputCm.value = '';
        }
      }
    });
  
    cmInputs.forEach(e => {
      e.style.display = (heightUnit === 'ft') ? 'none' : 'flex';
      if (heightUnit !== 'ft') {
        let firstInput = e.querySelector('input');
        if (firstInput) {
          firstInput.focus();
          htInputFt.required = false;
          htInputFt.style.display = 'none';
          htInputFt.value = '';
          htInputIn.value = '';
          htInputCm.required = true;
          htInputCm.style.display = 'block';
        }
      }
    });
  }

  // Function to toggle unit metric inputs for current weight.
  function toggleCurrentWtInputs() {
    currentWeightUnit = document.querySelector('input[name="current-weight-unit"]:checked').value;
    let kgInputs = document.querySelectorAll('.current-wt-unit-input[data-unit="kg"]');
    let lbsInputs = document.querySelectorAll('.current-wt-unit-input[data-unit="lbs"]');
  
    lbsInputs.forEach(e => {
      e.style.display = (currentWeightUnit === 'lbs') ? 'flex' : 'none';
      if (currentWeightUnit === 'lbs') {
        let firstInput = e.querySelector('input');
        firstInput.required = true;
        if (firstInput) {
          firstInput.style.display = 'block';
          firstInput.focus();
        }
      } else {
         let htInput = e.querySelector('input');
         htInput.required = false;
         htInput.style.display = 'none';
         htInput.value = '';
      }
    });
  
    kgInputs.forEach(e => {
      e.style.display = (currentWeightUnit === 'lbs') ? 'none' : 'flex';
      if (currentWeightUnit !== 'lbs') {
        let firstInput = e.querySelector('input');
        firstInput.required = true;
        if (firstInput) {
          firstInput.style.display = 'block';
          firstInput.focus();
        }
      } else {
         let htInput = e.querySelector('input');
         htInput.required = false;
         htInput.style.display = 'none';
         htInput.value = '';
      }
    });
  }

  // Function to toggle unit metric inputs for target weight.
  function toggleTargetWtInputs() {
    targetWeightUnit = document.querySelector('input[name="target-weight-unit"]:checked').value;    
    let kgInputs = document.querySelectorAll('.target-wt-unit-input[data-unit="kg"]');
    let lbsInputs = document.querySelectorAll('.target-wt-unit-input[data-unit="lbs"]');
  
    lbsInputs.forEach(e => {
      e.style.display = (targetWeightUnit === 'lbs') ? 'flex' : 'none';
      if (targetWeightUnit === 'lbs') {
        let firstInput = e.querySelector('input');
        firstInput.required = true;
        if (firstInput) {
          firstInput.style.display = 'block';
          firstInput.focus();
        }
      } else {
         let htInput = e.querySelector('input');
         htInput.required = false;
         htInput.style.display = 'none';
         htInput.value = '';
      }
    });
  
    kgInputs.forEach(e => {
      e.style.display = (targetWeightUnit === 'lbs') ? 'none' : 'flex';
      if (targetWeightUnit !== 'lbs') {
        let firstInput = e.querySelector('input');
        firstInput.required = true;
        if (firstInput) {
          firstInput.style.display = 'block';
          firstInput.focus();
        }
      } else {
         let htInput = e.querySelector('input');
         htInput.required = false;
         htInput.style.display = 'none';
         htInput.value = '';
      }
    });
  }
});

function subsUsrKlaviyo(){
  var settings = {
    "async": true,
    "crossDomain": true,
    "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    "method": "POST",
    "headers": {
      "content-type": "application/x-www-form-urlencoded",
      "cache-control": "no-cache"
    },
    "data": {
      "g": "V9VThe", // LIST_ID 
      "email": email,
      "$fields": "$source, Goal, Activity, Workout, Calories, Diet, Age, Gender, Height(cm), Current-Weight(Kg), Target-Weight(Kg), Macro-Results, Personalised-Products",
      "$source": "Macro calculator",
      "$first_name": userName,
      "Goal": goal,
      "Activity": activity,
      "Workout": workout,
      "Diet": diet,
      "Calories":userCaloriesPerDay,
      "Age": age,
      "Gender": sex,
      "Height(cm)": height,
      "Current-Weight(Kg)": currentWeight,
      "Target-Weight(Kg)": targetWeight,
      "Macro-Results": macrosResult,
      "Personalised-Products":personalisedColl
    }
  };
  $.ajax(settings).done(function(response) {
    console.log(response);
  });
}
